import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from './icons/Icons';

const propTypes = {
  tipHead: PropTypes.string.isRequired,
  tipBody: PropTypes.string.isRequired
};

export default class LegacyToolTip extends React.Component {
  render() {
    return (
      <div className="rec-tool-tip">
        <div className="rec-tool-tip-trigger">
          <Icons.IconInfo />
        </div>
        <div className="rec-tool-tip-body">
          <h6>{this.props.tipHead}</h6>
          <p>{this.props.tipBody}</p>
        </div>
      </div>
    );
  }
}

LegacyToolTip.propTypes = propTypes;
